import SisterProperties from './SisterProperties';

export default SisterProperties;
